import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';

import { ApiError, ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';
import { UserType } from './useGetUsers';

export type UsersResponseType = UserType[];

export const useGetFranchiseOwners = (
  options: QueryOptions<UsersResponseType, AxiosError<ApiError>> = {}
) =>
  useQuery({
    queryFn: async (): Promise<UsersResponseType> => {
      const { data } = await api.get<ApiResponse<UsersResponseType>>(
        `/user/list?role=franchise_owner`
      );

      return data.data;
    },
    queryKey: ['users', 'franchise_owners'],
    ...options,
  });
